import { apiFetchJson } from "./apiClient";

export interface AssetSelectionRequest {
  assetId: number;
  includedSectionIds: number[];
  includedDiceTemplateIds: number[];
}

export interface PublishListingRequest {
  title: string;
  description: string;
  priceCents: number;
  currency?: string;
  assets: AssetSelectionRequest[];
}

export interface MarketplaceListingSummary {
  id: number;
  userId: number;
  title: string;
  description: string;
  /** @deprecated Derived from priceCents by the server for one release. Removed in 5c. */
  price: number;
  priceCents: number;
  currency: string;
  /** True only for a `paid` purchase belonging to the calling user. */
  owned: boolean;
  activatedAt: string | null;
  status: string;
}

export interface MarketplaceAssetSectionDetails {
  id: number;
  name: string;
  description: string;
  sectionOrder: number;
}

export interface MarketplaceAssetDiceTemplateDetails {
  id: number;
  name: string;
  diceNotation: string;
  modifier: number;
  description: string;
  skillType: string;
}

export interface MarketplaceAssetDetails {
  id: number;
  name: string;
  type: string;
  category: string;
  description: string;
  tags: string;
  imageUrl?: string;
  sections: MarketplaceAssetSectionDetails[];
  diceTemplates: MarketplaceAssetDiceTemplateDetails[];
}

export interface MarketplaceListingDetails extends MarketplaceListingSummary {
  assets: MarketplaceAssetDetails[];
}

export const marketplaceService = {
  publishListing: async (request: PublishListingRequest) => {
    return apiFetchJson<{ message: string }>("/api/protected/marketplace/publish", {
      method: "POST",
      body: JSON.stringify(request),
    });
  },

  getListings: async () => {
    return apiFetchJson<MarketplaceListingSummary[]>("/api/protected/marketplace/listings");
  },

  getListingDetails: async (id: number) => {
    return apiFetchJson<MarketplaceListingDetails>(`/api/protected/marketplace/listings/${id}`);
  },

  activateListing: async (id: number) => {
    return apiFetchJson<{ message: string }>(`/api/protected/marketplace/listings/${id}/activate`, {
      method: "POST",
    });
  },
};

export default marketplaceService;
